/**
 * Masonry Grid with lazy loading
 * @dependencies isotope-layout
 */
import Masonry from 'masonry-layout'

// Don't use js-masonry because masonry use it
const grids = Array.from(document.getElementsByClassName('js-grid-masonry'));
const masonryOptions = {
  itemSelector: '.js-grid-item',
  columnWidth: '.js-grid-sizer',
  gutter: '.js-grid-gutter',
  percentPosition: true,
  resize: true,
  stagger: 30
}
const bp = 768

if (grids.length) {
  for (const grid of grids) {
    // General Layout
    // We init the masonry instance but we dont fire it yet
    let currentWidth = window.innerWidth
    const resizeObserver = new ResizeObserver(() => {
      const newWidth = window.innerWidth;
      if (newWidth === currentWidth) return
      const masonry = Masonry.data(grid)

      if (typeof masonry === 'undefined' && newWidth > bp) {
        const masonry = new Masonry(grid, masonryOptions);
        masonry.layout();
      } else if (masonry && newWidth <= bp) {
        masonry.destroy()
      }

      currentWidth = window.innerWidth
    })
    resizeObserver.observe(grid);

    if (window.innerWidth > bp) {
      const masonry = new Masonry(grid, masonryOptions);
      masonry.layout()
    }
  }
}
